import { Collapse } from "antd"
import ProposalRecipients from "./ProposalRecipients"
import ProposalWorkareas from "./ProposalWorkareas"
import ProposalTermsAndConditions from "./ProposalTermsAndConditions"
import ProposalPaymentSchedule from "./ProposalPaymentSchedule"
import ProposalTimeline from "./ProposalTimeline"
import ProposalVersionRow from "./ProposalVersionRow"
import ProposalVersionActions from "./ProposalVersionActions"
import { Proposal, ProposalJobData } from "./proposalsModel"

type Props = {
  proposals: Proposal[]
  currentProposalId?: number
  job: ProposalJobData
  onInvalidateJob: () => void
  onViewLink: (link: string) => void
  onSend: (proposal: Proposal) => void
  onPreview: (proposal: Proposal) => void
  onManage: (proposal: Proposal) => void
}

const ProposalVersionList = ({
  proposals,
  currentProposalId,
  job,
  onInvalidateJob,
  onViewLink,
  onSend,
  onPreview,
  onManage
}: Props) => {
  return <Collapse
    defaultActiveKey={currentProposalId !== undefined ? [`${currentProposalId}`] : []}
    items={proposals.map(proposal => ({
      key: `${proposal.id}`,
      label: <ProposalVersionRow proposal={proposal} />,
      children: <div>
        <ProposalVersionActions
          proposal={proposal}
          canSend={job?.customer?.isActive ?? false}
          onViewLink={onViewLink}
          onSend={onSend}
          onPreview={onPreview}
          onManage={onManage}
        />
        <ProposalTimeline latestProposal={proposal} />
        <ProposalRecipients redesign latestProposal={proposal} onInvalidateJob={onInvalidateJob} />
        <ProposalWorkareas redesign workareas={proposal.workareas ?? []} jobId={job.id} />
        <ProposalTermsAndConditions redesign termsAndConditions={proposal.termsAndConditions} />
        <ProposalPaymentSchedule
          latestProposalId={proposal.id}
          workareas={proposal.workareas ?? []}
        />
      </div>
    }))}
  />
}

export default ProposalVersionList
